import script from "./DepthContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./DepthContainer.vue?vue&type=script&setup=true&lang=js"

import "./DepthContainer.vue?vue&type=style&index=0&id=0b6dfcaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b6dfcaa"]])

export default __exports__